import React from 'react'
import { MaybeLoaded } from 'json-react-layouts-data-loader'

import { Whiskey } from '../../collections/whiskey/Whiskey'
import {
    ContentDataDefinitionLoader,
    CollectionDataLoaded,
    ContentDataTypes,
} from '@news-mono/web-common'
import {
    CollectionRouteProps,
    calculateExpectedCardCountFromContentData,
} from '../../collections/collections-props.routing'
import {
    LoadMore,
    LoadMoreRouteProps,
} from '../../collections-new-loadmore/LoadMore/LoadMore'
import {
    createRegisterableComponentWithData,
    ComponentServices,
} from '@news-mono/web-common'
import { ResponsiveContainer } from '../../content/Picture/responsive'

export interface TheWestProps extends WhiskeyProps {
    imageWidths?: number
}

interface WhiskeyProps
    extends CollectionRouteProps,
        LoadMoreRouteProps,
        ResponsiveContainer {
    initialColumns?: number
    intermediateColumns?: number
    finalColumns?: number
}

const renderWhiskey = (
    props: WhiskeyProps & TheWestProps,
    data: MaybeLoaded<CollectionDataLoaded> & {
        dataDefinitionArgs: ContentDataTypes
    },
    services: ComponentServices,
) => {
    return (
        <LoadMore
            dataDefinition={data.dataDefinitionArgs}
            services={services}
            loadMoreEnabled={props.loadMoreEnabled === true}
            data={data}
            render={(loadMoreData) => {
                return (
                    <Whiskey
                        items={
                            loadMoreData.loaded
                                ? {
                                      loaded: true,
                                      result: loadMoreData.result.publications,
                                  }
                                : { loaded: false }
                        }
                        expectedCards={calculateExpectedCardCountFromContentData(
                            data.dataDefinitionArgs,
                        )}
                        initialColumns={props.initialColumns}
                        intermediateColumns={props.intermediateColumns}
                        finalColumns={props.finalColumns}
                        verticalSpacing={props.verticalSpacing}
                        containerWidthRatios={props.containerWidthRatios}
                        onEvent={services.onEvent}
                    />
                )
            }}
        />
    )
}

export const WhiskeyRegistration = createRegisterableComponentWithData(
    'whiskey',
    ContentDataDefinitionLoader,
    (props: TheWestProps, data, services) =>
        renderWhiskey(
            { ...props, imageWidths: props.imageWidths },
            data,
            services,
        ),
)
